// Base Class for all items that need to be animated on scroll

DW.ScrollAnimationItem = function(container) {
	this.container = container;
};

DW.ScrollAnimationItem.prototype = {
	inVerticalView : function(scrollTop, windowHeight) {
		var rect = this.container.getBoundingClientRect();
		return (rect.top < window.innerHeight && rect.bottom > 0);
	},

	belowView : function(scrollTop, windowHeight) {
		var rect = this.container.getBoundingClientRect();
		return (scrollTop + windowHeight) < rect.top;
	},

	animateWhileInView : function() {
		this.container.classList.add('animated');
	},

	resetAnimation : function() {
		this.container.classList.remove('animated');
	},
};
